import { Context } from 'react';
import withNotificationContext from 'src/contexts/NotificationContextBase/hoc';
import { INotificationManager } from 'src/contexts/NotificationContextBase/types';
import Notifications, { INotificationDisplay } from 'src/elements/Notifications';

const ContextualNotifications = (
  props: INotificationDisplay,
  context: Context<INotificationManager>
) => withNotificationContext(Notifications, context)(props);

export default ContextualNotifications;
